<template>
  <div>
    <h2>充值记录</h2>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Table
      :width="width"
      border
      stripe
      highlight-row
      ref="currentRowTable"
      :columns="columns"
      :data="dataList"
    ></Table>
    <div style="padding: 10px 0px 0px 0px">
      <Page
        :current="page"
        :total="dataCount"
        :page-size="pageAmount"
        show-sizer
        show-total
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      ></Page>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    meterId: ""
  },
  mounted() {
    this.getRecordPage(this.meterId);
  },
  data() {
    return {
      isSpinShow: false,
      height: document.body.clientHeight * 0.8,
      width: document.body.clientWidth,
      columns: [
        {
          title: "缴费时间",
          fixed: "left",
          width: document.body.clientWidth * 0.4,
          key: "recordRechargeDate",
          render: function(h, params) {
            return h(
              "div",
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(this.row.recordRechargeDate)
              )
            ); /*这里的this.row能够获取当前行的数据*/
          }
        },
        {
          title: "用户",
          width: document.body.clientWidth * 0.2,
          key: "recordRechargeCustomerName"
        },
        {
          title: "缴费金额（元）",
          width: document.body.clientWidth * 0.2,
          key: "recordRechargePrice"
        },
        {
          title: "充值气量（m³）",
          width: document.body.clientWidth * 0.2,
          key: "recordRechargeFlow"
        },
        {
          title: "营业员",
          width: document.body.clientWidth * 0.2,
          key: "recordRechargePersonnelName"
        }
      ],
      dataList: [],
      dataCount: 0,
      pageAmount: 10,
      page: 1,
      meterId: ""
    };
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getRecordPage(this.meterId);
    },
    changePageSize(size) {
      this.pageAmount = size;
      this.getRecordPage(this.meterId);
    },
    getRecordPage(param) {
      // param = "19041300000001";
      this.meterId = param;
      this.isSpinShow = true;
      var that = this;
      var recordModel = {};
      recordModel["recordRechargeMeterId"] = param;
      //请求设备基础数据
      $.ajax({
        url:
          "/api/recharge/getRechargeRecordList?page=" +
          this.page +
          "&pageAmount=" +
          this.pageAmount,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(recordModel),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.dataList = data.body.resultList;
          that.dataCount = data.body.amount;
          that.isSpinShow = false;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    }
  }
};
</script>
